import { ready } from '~/core';
import { addEvents } from '~/utils';

ready('accordion', '.accordion-trigger', trigger => {
	const header =
		document.querySelector('.headerMain') ||
		document.querySelector('.header') ||
		document.body.querySelector('header');
	const accordion = trigger.closest('.accordion');
	const item = trigger.closest('.accordion-item');

	const animate = (start, end) => {
		item.animate([{ height: `${start}px` }, { height: `${end}px` }], {
			duration: 350,
			easing: 'ease'
		});
	};

	const open = () => {
		let start = item.offsetHeight;
		let end;
		accordion.querySelectorAll('.accordion-open').forEach(open => open.classList.remove('accordion-open'));
		item.classList.add('accordion-open');
		end = item.offsetHeight;

		animate(start, end);

		if (window.innerWidth < 768) {
			setTimeout(() => {
				window.scrollBy({
					top: item.getBoundingClientRect().top - header ? header.offsetHeight : 0,
					behavior: 'smooth'
				});
			});
		}
	};

	const close = () => {
		let start = item.offsetHeight;
		let end;
		item.classList.remove('accordion-open');
		end = item.offsetHeight;

		animate(start, end);
	};

	addEvents(trigger, 'click.prevent enter', () =>
		item.classList.contains('accordion-open') ? close() : open()
	);

	if (window.location.hash.length) {
		if (window.location.hash.slice(1) === item.getAttribute('data-hash')) open();
	}
});
